import { useToastStore } from '@/stores/toast.store';
import { Toast } from './Toast';

/**
 * ToastContainer Component
 *
 * Global container for rendering all active toast notifications
 *
 * Features:
 * - Fixed position (top-right)
 * - High z-index for visibility above modals
 * - Stacks toasts vertically
 * - Subscribes to toast store
 * - Responsive positioning
 *
 * Usage:
 * Add once to App.tsx or main layout:
 * ```tsx
 * <ToastContainer />
 * ```
 */
export const ToastContainer = () => {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className="fixed top-4 right-4 z-toast flex flex-col gap-3 pointer-events-none"
      aria-live="polite"
      aria-atomic="false"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast toast={toast} onClose={() => removeToast(toast.id)} />
        </div>
      ))}
    </div>
  );
};
